module.exports = __webpack_public_path__ + "img/img-parts-senaka03.fb7cda69.png";